<template>
	<div id="main">
		<common-header></common-header>
		<!-- 分类 -->
		<div class="flex flex-start">
			<div class="category">
				<el-menu default-active="" class="el-menu-vertical-demo" :collapse="true">
					<el-submenu v-for="(fmenu, index) in categoryList" :index="fmenu.name" :key="index">
						<template slot="title">
							<div class="cate_text" @click="toList(fmenu.id,fmenu.name, 1)">{{ fmenu.name }}</div>
						</template>
						<el-submenu v-for="(smenu, skey) in fmenu.children" :index="smenu.name" :key="skey">
							<div class="cate_text" slot="title" @click="toList(smenu.id,smenu.name, 2)">{{ smenu.name }}</div>
							<el-menu-item v-for="(tmenu, tkey) in smenu.children" :index="tmenu.name" :key="tkey" @click="toList(tmenu.id,tmenu.name, 3)">
								<div class="cate_text">{{ tmenu.name }}</div>
							</el-menu-item>
						</el-submenu>
					</el-submenu>
				</el-menu>
			</div>
			<div class="banner" style="width: 800px;height: 400px;">
				<el-carousel :interval="4000" height="400px">
					<el-carousel-item v-for="(item, index) in carouselList" :key="index"><img :src="getWebPic(item.pic)" style="width: 100%;height: 100%;" /></el-carousel-item>
				</el-carousel>
			</div>
		</div>
		<!-- 推荐分类 -->
		<div class="goods" v-if="goodsList.length">
			<div class="flex flex-start text-left">
				<img src="../../assets/temp/h1.png" />
				<div style="padding: 20px;">
					<p class="tit">分类精选</p>
					<p class="tit2">Competitive Products For You</p>
				</div>
			</div>
			<div class="goods-item" v-for="(goods, gkey) in goodsList" :key="gkey">
				<div class="goods-backimg"><el-image :src="getWebPic(cateList[gkey].indexbackimg)" fit="fill"></el-image></div>
				<div class="section">
					<div class="section-item" v-for="(item, index) in goods" :key="index" @click="toDetail(item.id)">
						<div class="goods-pic"><img :src="getWebPic(item.smpic)" alt="" /></div>
						<p class="goods-title" :title="item.name">{{ item.name }}</p>
						<p class="flex">
							<span class="goods-price">￥{{ item.price }}</span>
							<span class="goods-sale">销量 {{ item.sales }}</span>
						</p>
					</div>
				</div>
			</div>
		</div>
		<!-- 猜你喜欢 -->
		<div class="guess" v-if="guessLike.length">
			<div class="flex flex-start text-left">
				<img src="../../assets/temp/h1.png" />
				<div style="padding: 20px;">
					<p class="tit">猜你喜欢</p>
					<p class="tit2">Guess You Like It</p>
				</div>
			</div>
			<div class="goods-item">
				<div class="section">
					<div class="section-item" v-for="(item, index) in guessLike" :key="index" @click="toDetail(item.id)">
						<div class="goods-pic"><img :src="getWebPic(item.smpic)" alt="" /></div>
						<p class="goods-title" :title="item.name">{{ item.name }}</p>
						<p class="flex">
							<span class="goods-price">￥{{ item.minprice }}</span>
							<span class="goods-sale">销量 {{ item.sales }}</span>
						</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import commonHeader from '../../components/common/commonHeader.vue';
export default {
	name: 'home',
	components:{
		commonHeader
	},
	data() {
		return {
			carouselList: [],
			tuangouList: [],
			cateList: [],
			goodsList: [],
			guessLike: [],
			categoryList: []
		};
	},
	methods: {
		...mapActions({
			exit: 'auth/logout'
		}),
		getIndexInfo(active) {
			this.$request
				.post('/home.goods/getIndexInfo')
				.then(res => {
					console.log(res.data);
					this.carouselList = res.data.bannerList;
					this.cateList = res.data.cateList;
					this.goodsList = res.data.goodsList;
					this.guessLike = res.data.guessLike;
				})
				.catch(err => {
					console.log('err');
				});
		},
		getcategoryList() {
			this.$request
				.post('/home.goods/getWebCategoryList', { level: 4 })
				.then(res => {
					console.log(res.data);
					this.categoryList = res.data.categoryList;
				})
				.catch(err => {
					console.log('err');
				});
		},
		toList(id,name,level) {
			console.log(id, level);
			this.$router.push({'path':'/goods','query':{'cateid':id,'level':level,'search':name}});
		}
	},
	mounted() {
		console.log('router.id:', this.$route.params.id);
		this.getcategoryList();
		this.getIndexInfo();
	}
};
</script>

<style lang="scss">
.category {
	width: 200px;
	.el-menu--collapse {
		width: 100%;
	}
}
.cate_text {
	&:hover {
		color: #55aaff;
	}
}
</style>
